import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCustomer } from 'src/app/auth/ngrx/customer.selectors';
import { SendAppointmentRequest } from 'src/app/calendar/interfaces/send_appointment_request';
import { sendAppointmentReminder } from 'src/app/calendar/ngrx/calendar.actions';
import { CustomerDto } from 'src/app/auth/interfaces/customer_dto';
import { IcsService } from './ics.service';

@Injectable({
  providedIn: 'root',
})
export class ReminderService {

    constructor(private store: Store<any>, private icsService: IcsService) {}

    sendReminder(reminder: any) {
        let appointmentToNotify = reminder.appointment;
        let studentToNotify = reminder.student;
        let customer$ = this.store.select(selectCustomer);
        customer$.pipe(take(1)).subscribe(async (customer) => {
          let icsFile = await this.icsService.generateIcsFile(appointmentToNotify, customer, studentToNotify);
          if (!icsFile) {
            return;
          }
    
          let sendAppointmentRequest: SendAppointmentRequest = {
            student: studentToNotify,
            customer: customer,
            recipient: studentToNotify.mail_student,
            bcc: null,
            sender: customer.mail_customer,
            subject: "Terminbestätigung",
            content: "",
            date: new Date(appointmentToNotify.StartTime).toLocaleDateString("fr-CH"),
            time: new Date(appointmentToNotify.StartTime).toLocaleTimeString("fr-CH", { hour: "2-digit", minute: "2-digit" }) + " - " + new Date(appointmentToNotify.EndTime).toLocaleTimeString("fr-CH", { hour: "2-digit", minute: "2-digit" }),
            type: appointmentToNotify.Type,
            appointmentAttachment: icsFile,
            appointmentId: appointmentToNotify.Id,
          };
    
          this.store.dispatch(sendAppointmentReminder({ sendAppointmentRequest }));
        });
      }
}
